import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import find from 'lodash/find'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import sortBy from 'lodash/sortBy'
import toNumber from 'lodash/toNumber'
import last from 'lodash/last'
import moment from '../../../lib/moment.js'
import { Button, Container, Row, Col } from 'reactstrap'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  leaveGenerationAction,
  reportAction,
  companyAction,
  lobAction,
} from './../../../actions/'
import {
  modalSelector,
  authSelector,
  leaveGenerationSelector,
  reportSelector,
  companySelector,
  lobSelector,
} from './../../../selectors'
import {
  checkModifiedBy,
  createListOfYears,
} from '../../../function'
import Searchbar from '../../../components/searchbar'
import withLayout from '../../../helpers/withLayout'
import LeaveGenerationForm from '../../../components/leave-generation'
import LeaveGenerationTable from '../../../components/table-leave-generation'
import * as reportHelper from '../../../components/report/helpers/report'

import ExportModal from '../../../components/leave-generation/ExportModal'

class LeaveGenerationPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLeaveGenerationReportData.leaveGenerationUsers')) {
      set(tempState, 'leaveGenerationUsers', get(nextProps, 'getLeaveGenerationReportData.leaveGenerationUsers'))
      nextProps.resetGetLeaveGenerationReport()
    }
    if (get(nextProps, 'getLeaveGenerationData')) {
      const generation = get(nextProps, 'getLeaveGenerationData.prettyLeaveGeneration')
      set(tempState, 'prettyLeaveGeneration', generation)
      const years = createListOfYears(generation)
      const thisYear = moment().year()
      set(tempState, 'years', years)
      set(tempState, 'year', thisYear)
      const year = generation[thisYear] ? thisYear :
        last(sortBy(Object.keys(generation), [g => toNumber(g)]))
      const temp = []
      let updated = ''
      let updated_by = ''
      generation[year].map(gen => {
        const g = {}
        g.leave_generation_id = gen.leave_generation._id
        g.name = gen.name
        g.total = gen.meta.total
        g.approved = gen.meta.approved
        g.pending = gen.meta.pending
        g.remaining = gen.meta.remaining
        g.start_date = moment(gen.leave_generation.start_date)
        g.end_date = moment(gen.leave_generation.end_date)
        if (updated === '') {
          updated = gen.leave_generation.updated
          updated_by = gen.leave_generation.updated_by
        } else if (moment(updated).isBefore(gen.updated)) {
          updated = gen.leave_generation.pdated
          updated_by = gen.leave_generation.updated_by
        }
        temp.push(g)
        return gen
      })
      set(tempState, 'updated', updated)
      set(tempState, 'updated_by', checkModifiedBy(updated_by, prevState.employees))
      set(tempState, 'leave_generations', temp)
      nextProps.resetGetLeaveGeneration()
    }
    if (get(nextProps, 'getCompanyData') !== prevState.companys) {
      set(tempState, 'companys', get(nextProps, 'getCompanyData'))
    }
    if (get(nextProps, 'getLOBData') !== prevState.lobs) {
      set(tempState, 'lobs', get(nextProps, 'getLOBData'))
    }
    if (get(nextProps, 'exportLeaveGenerationData')) {
      window.open(get(nextProps, 'exportLeaveGenerationData'))
      nextProps.resetExportLeaveGeneration()
    }
    if (get(nextProps, 'exportLeaveGenerationUserData')) {
      window.open(get(nextProps, 'exportLeaveGenerationUserData'))
      nextProps.resetExportLeaveGenerationUser()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      rowID: '',
      isSpan: false,
      leaveGenerationID: '',
      prettyLeaveGeneration: null,
      years: [],
      leaveGeneration: [],
      leave_generations: [],

      name: '',
      emp_code: '',
      company: '',
      lob: '',
      year: '',
      start_date: null,
      end_date: null,
      updated: '',
      updated_by: '',
      search: '',
      sort_by: 'emp_code',
      sort_order: 'desc',

      export_modal: false,
    }
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getCompany(access_token)
    this.props.getLOB(access_token)
    this.props.getLeaveGenerationReport(access_token)
  }

  handleInput = (e) => {
    const generation = this.state.prettyLeaveGeneration
    const temp = []
    generation[e.target.value].map(gen => {
      const g = {}
      g.leave_generation_id = gen.leave_generation._id
      g.name = gen.name
      g.total = gen.meta.total
      g.approved = gen.meta.approved
      g.pending = gen.meta.pending
      g.remaining = gen.meta.remaining
      g.start_date = moment(gen.leave_generation.start_date)
      g.end_date = moment(gen.leave_generation.end_date)
      temp.push(g)
      return gen
    })
    this.setState({
      [e.target.name]: e.target.value,
      leave_generations: temp,
    })
  }

  handleClickRow = (span, id, editID) => {
    this.setState({
      isSpan: span,
      leaveGenerationID: id,
      rowID: editID,
    })
    if (span) {
      const access_token = localStorage.getItem('access_token')
      this.props.getLeaveGeneration(id, access_token)
      const { leaveGenerationUsers, companys, lobs } = this.state
      const employee = find(reportHelper.generateLeaveGenerationList(
        leaveGenerationUsers, companys, lobs), {
        _id: id,
      })
      this.setState({
        name: employee.name,
        emp_code: employee.emp_code,
        company: employee.company,
        lob: employee.lob,
      })
    }
  }

  handleSearch = (e) => {
    if (e.target.value === '') {
      this.setState({ leaveGenerationUsers: this.state.leaveGenerationUsers, search: '' })
    } else this.setState({ search: e.target.value })
  }

  searchEmployees = (element) => {
    const search = this.state.search.toLowerCase()
    const nick_name = element.nick_name.toLowerCase()
    const name = `${element.first_name.toLowerCase()} ${element.last_name.toLowerCase()}`
    const emp_code = element.emp_code.toLowerCase()
    const lob = element.lob.toLowerCase()
    const company = element.company.toLowerCase()
    return name.includes(search) || emp_code.includes(search) || nick_name.includes(search)
    || lob.includes(search) || company.includes(search)
  }

  sortBy = (type, order) => {
    this.setState({ sort_by: type, sort_order: order ? 'asc' : 'desc' })
  }

  sortGeneration = (data) => {
    if (this.state.sort_by === 'emp_code') return orderBy(data, ['emp_code'], [this.state.sort_order])
    else if (this.state.sort_by === 'company') return orderBy(data, ['company'], [this.state.sort_order])
    else if (this.state.sort_by === 'lob') return orderBy(data, ['lob'], [this.state.sort_order])
    else if (this.state.sort_by === 'name') return orderBy(data, ['name'], [this.state.sort_order])
    return data
  }

  toggleExportModal = () => {
    this.setState(state => ({
      export_modal: !state.export_modal,
    }))
  }

  exportAllMethod = year => {
    const access_token = localStorage.getItem('access_token')
    this.props.exportLeaveGeneration(year, access_token)
  }

  exportIndividualMethod = () => {
    const { leaveGenerationID, year } = this.state
    const access_token = localStorage.getItem('access_token')
    this.props.exportLeaveGenerationUser(leaveGenerationID, year, access_token)
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsPMUser = get(this.props, 'authData.user.is_pm_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectReport.isAuthenticated')
    || get(this.props, 'redirectGeneration.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
    || get(this.props, 'redirectReport.redirect')
    || get(this.props, 'redirectGeneration.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (
      IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsLOBLeadUser !== undefined &&
      IsManagementUser !== undefined &&
      IsPMUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsLOBLeadUser || IsManagementUser || IsPMUser)) {
      window.location = '/home'
    }
    const button = (
      <NewButton
        color="info"
        onClick={ this.exportIndividualMethod }
      >
        <div>Export</div>
      </NewButton>
    )
    const isFetching = get(this.props, 'getIsFetching')
    const { leaveGenerationUsers, companys, lobs } = this.state
    const leaveGenerationList = reportHelper.generateLeaveGenerationList(
      leaveGenerationUsers, companys, lobs)

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <Searchbar
          export={ this.toggleExportModal }
          handleSearch={ this.handleSearch }
          { ...this.state }
        />
        <ExportModal
          isOpen={ this.state.export_modal }
          toggle={ this.toggleExportModal }
          exportMethod={ this.exportAllMethod }
        />
        <Row noGutters>
          <Col>
            <LeaveGenerationTable
              handleInput={ this.handleInput }
              handleClickRow={ this.handleClickRow }
              sortBy={ this.sortBy }
              data={ this.sortGeneration(
                leaveGenerationList.filter(this.searchEmployees)
              ) }
              { ...this.state }
            />
          </Col>
          {
            this.state.isSpan &&
            <Col>
              <LeaveGenerationForm
                handleInput={ this.handleInput }
                button={ button }
                { ...this.state }
                handleClickRow={ this.handleClickRow }
                handleLeaveType={ this.handleLeaveType }
                showDiscard={ () => this.handleClickRow(false, '', '') }
              />
            </Col>
          }
        </Row>
      </Wrapper>
    )
  }
}

LeaveGenerationPage.propTypes = {
  resetAuth: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  getLeaveGenerationReport: PropTypes.func.isRequired,
  getLeaveGeneration: PropTypes.func.isRequired,
  exportLeaveGeneration: PropTypes.func.isRequired,
  exportLeaveGenerationUser: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  getIsFetchingReport: reportSelector.getIsFetching,
  getIsFetchingGeneration: leaveGenerationSelector.getIsFetching,
  redirectAuth: authSelector.redirectAuth,
  redirectReport: reportSelector.redirectReport,
  redirectGeneration: leaveGenerationSelector.redirectGeneration,
  getLeaveGenerationData: leaveGenerationSelector.getLeaveGenerationData,
  exportLeaveGenerationData: leaveGenerationSelector.exportLeaveGenerationData,
  exportLeaveGenerationUserData: leaveGenerationSelector.exportLeaveGenerationUserData,
  getCompanyData: companySelector.getListCompany,
  getLOBData: lobSelector.getListLOB,
  getLeaveGenerationReportData: reportSelector.getLeaveGenerationReportData,
  getIsFetching: leaveGenerationSelector.getIsFetching,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getLeaveGeneration: leaveGenerationAction.getLeaveGeneration,
  resetGetLeaveGeneration: leaveGenerationAction.resetGetLeaveGeneration,
  resetEditLeaveGeneration: leaveGenerationAction.resetEditLeaveGeneration,
  exportLeaveGeneration: leaveGenerationAction.exportLeaveGeneration,
  resetExportLeaveGeneration: leaveGenerationAction.resetExportLeaveGeneration,
  exportLeaveGenerationUser: leaveGenerationAction.exportLeaveGenerationUser,
  resetExportLeaveGenerationUser: leaveGenerationAction.resetExportLeaveGenerationUser,
  getCompany: companyAction.getCompany,
  getLOB: lobAction.getLOB,
  getLeaveGenerationReport: reportAction.getLeaveGenerationReport,
  resetGetLeaveGenerationReport: reportAction.resetGetLeaveGenerationReport,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(LeaveGenerationPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`




// WEBPACK FOOTER //
// ./src/pages/report/leave-generation/index.js